import { themeClasses } from '@member-portal/ui';

function ContactPage() {
  return (
    <div className="fhxd-chrome-top">
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/images/Canaves-Oia-Suites-signature5.jpg)' }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-title font-normal text-3xl md:text-5xl lg:text-7xl tracking-wider uppercase text-white mb-6">
            Contact Us
          </h1>
          <p className="font-body font-normal leading-relaxed tracking-form text-white/90">
            We'd love to hear from you
          </p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-24 bg-theme-bg">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className={`${themeClasses.title.h3} mb-8`}>
            Get in Touch
          </h2>
          <p className={`${themeClasses.text.body} mb-8`}>
            For inquiries, please reach out to us at:
          </p>
          <a
            href="mailto:info@fourhundredbydesign.com"
            className={`${themeClasses.text.body} text-xl underline hover:opacity-80 transition-opacity`}
          >
            info@fourhundredbydesign.com
          </a>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
